import Model from './Model'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

export default class File extends Model {
  resource() {
    return 'file'
  }

  get addedDate() {
    return dayjs.utc(this.created_at).format('DD/MMM/YYYY').toUpperCase()
  }
}
